<template>
  <div class="chart-container">
    <div class="chart-header">
      <h2>Médias Trimestrais por Ano Letivo</h2>
      <div class="chart-actions">
        <div class="controls">
      <v-select class="year-select" :items="anoLectivoAll" v-model="anoLectivoSelected" @change="carregarDados()"
        item-value="descricao" item-text="novadescricao" label="Ano letivo" outlined dense hide-details></v-select>
    </div>
        <button @click="carregarDados" class="refresh-btn" title="Recarregar dados">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21.5 2v6h-6M2.5 22v-6h6M22 11.5a10 10 0 0 1-17.2 6.8M2 12.5a10 10 0 0 1 17.2-6.8"/>
          </svg>
        </button>
      </div>
    </div>

    <div class="chart-wrapper">
      <loading v-if="isLoading" />
      <div v-else-if="!chartData" class="no-data">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        <p>Nenhum dado disponível</p>
        <button @click="carregarDados" class="retry-btn">Tentar novamente</button>
      </div>
      <div v-else class="chart-content">
        <bar-chart :chart-data="chartData" :options="chartOptions" />
        <div class="chart-legend" :class="{ 'collapsed': legendCollapsed }">
          <div v-for="dataset in chartData.datasets" :key="dataset.label" class="legend-item">
            <span class="legend-color" :style="{ backgroundColor: dataset.backgroundColor }"></span>
            <span class="legend-label">{{ dataset.label }}</span>
            <span class="legend-value" v-if="!legendCollapsed">
              {{ calculateAverage(dataset.data) }} (média)
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import axios from "../../../plugins/axios"
const ls = require('local-storage')

export default {
  components: {
    loading: () => import("../../../components/loading.vue"),
    'bar-chart': {
      extends: Bar,
      props: ['chartData', 'options'],
      mounted() {
        this.renderChart(this.chartData, this.options)
      },
      watch: {
        chartData(newData) {
          this.renderChart(newData, this.options)
        }
      }
    }
  },
  data() {
    return {
        anoLectivoAll: [],
      anoLectivoSelected: ls.get('anolectivo'),
      mediaPorTrimestreAll: [],
      isLoading: false,
      chartData: null,
      legendCollapsed: false,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: false
          },
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                return `${context.dataset.label}: ${context.raw.toFixed(2)}`
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            max: 20,
            title: {
              display: true,
              text: 'Média',
              font: {
                weight: 'bold'
              }
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          },
          x: {
            grid: {
              display: false
            }
          }
        },
        animation: {
          duration: 1000
        },
        elements: {
          bar: {
            borderRadius: 4,
            borderSkipped: false
          }
        }
      }
    }
  },

  async created() {
     await this.carregarAnosLectivos();
    await this.carregarDados()
  },

  methods: {
     async carregarAnosLectivos() {
      this.isLoading = true;
      try {
        this.anoLectivoAll = await axios.get(`/getAnosLectivosAll`).then((res) => res.data);
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async carregarDados() {
      this.isLoading = true
      try {

        let anolectivo;

        if (this.anoLectivoSelected) {
          anolectivo = this.anoLectivoSelected
        } else {
          anolectivo = ls.get('anolectivo')
        }

        const response = await axios.get(`/getMediaPorTrimestre/${anolectivo}`)
        this.mediaPorTrimestreAll = response.data

        if (this.mediaPorTrimestreAll.length > 0) {
          const anos = this.mediaPorTrimestreAll.map(item => item.anoLectivo)
          const primeiro = this.mediaPorTrimestreAll.map(item => item.media_primeiro_trimestre)
          const segundo = this.mediaPorTrimestreAll.map(item => item.media_segundo_trimestre)
          const terceiro = this.mediaPorTrimestreAll.map(item => item.media_terceiro_trimestre)

          this.chartData = {
            labels: anos,
            datasets: [
              {
                label: '1º Trimestre',
                backgroundColor: 'rgba(66, 165, 245, 0.8)',
                borderColor: 'rgba(66, 165, 245, 1)',
                borderWidth: 1,
                data: primeiro
              },
              {
                label: '2º Trimestre',
                backgroundColor: 'rgba(102, 187, 106, 0.8)',
                borderColor: 'rgba(102, 187, 106, 1)',
                borderWidth: 1,
                data: segundo
              },
              {
                label: '3º Trimestre',
                backgroundColor: 'rgba(255, 167, 38, 0.8)',
                borderColor: 'rgba(255, 167, 38, 1)',
                borderWidth: 1,
                data: terceiro
              }
            ]
          }
        } else {
          this.chartData = null
        }
      } catch (error) {
        console.error("Erro ao carregar dados:", error)
        this.chartData = null
      } finally {
        this.isLoading = false
      }
    },
    
    calculateAverage(data) {
      const sum = data.reduce((a, b) => a + b, 0)
      return (sum / data.length).toFixed(2)
    }
  }
}
</script>

<style scoped>
.chart-container {
  background: white;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  padding: 24px;
  margin: 0 auto;
  font-family: 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.chart-header h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.4rem;
  font-weight: 600;
}

.chart-actions {
  display: flex;
  gap: 10px;
}

.refresh-btn, .legend-toggle {
  background: #f8f9fa;
  border: none;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.refresh-btn:hover, .legend-toggle:hover {
  background: #e9ecef;
  transform: translateY(-1px);
}

.chart-wrapper {
  height: 400px;
  position: relative;
}

.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #6c757d;
  gap: 12px;
}

.no-data p {
  margin: 0;
  font-size: 1.1rem;
}

.retry-btn {
  background: #42A5F5;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 10px;
}

.retry-btn:hover {
  background: #1E88E5;
}

.chart-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.chart-legend {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.chart-legend.collapsed {
  justify-content: flex-start;
  padding: 8px 12px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #495057;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  flex-shrink: 0;
}

.legend-label {
  font-weight: 500;
  white-space: nowrap;
}

.legend-value {
  color: #6c757d;
  font-size: 0.85rem;
}

.chart-legend.collapsed .legend-value {
  display: none;
}

@media (max-width: 768px) {
  .chart-container {
    padding: 16px;
  }
  
  .chart-header h2 {
    font-size: 1.2rem;
  }
  
  .chart-legend {
    flex-wrap: wrap;
    gap: 12px;
  }
  
  .chart-wrapper {
    height: 350px;
  }
}
</style>